var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 0H9.33333H5.25H1.16667C0.525 0 0 0.525 0 1.16667V12.8333C0 13.475 0.525 14 1.16667 14H12.8333C13.475 14 14 13.475 14 12.8333V1.16667C14 0.525 13.475 0 12.8333 0ZM5.83333 1.16667H8.75V2.33333H5.83333V1.16667ZM12.8333 12.8333H1.16667V1.16667H5.25V2.91667H9.33333V1.16667H12.8333V12.8333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85833 7.34984C9.8 7.2915 9.8 7.23317 9.74167 7.17484L7.40833 4.8415C7.175 4.60817 6.825 4.60817 6.59167 4.8415C6.35833 5.07484 6.35833 5.42484 6.59167 5.65817L7.93333 6.99984H4.08333C3.73333 6.99984 3.5 7.23317 3.5 7.58317C3.5 7.93317 3.73333 8.1665 4.08333 8.1665H7.93333L6.59167 9.50817C6.35833 9.7415 6.35833 10.0915 6.59167 10.3248C6.70833 10.4415 6.88333 10.4998 7 10.4998C7.11667 10.4998 7.29167 10.4415 7.40833 10.3248L9.74167 7.9915C9.8 7.93317 9.85833 7.87484 9.85833 7.8165C9.91667 7.6415 9.91667 7.52484 9.85833 7.34984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreorder);
export default __webpack_public_path__ + "static/media/pre order.9d028dc98d1ac7b0a92b8190f651276f.svg";
export { ForwardRef as ReactComponent };